import { useContext } from 'react';

import ApplicationConfigContext from 'containers/ApplicationConfigContext';

const useApplicationConfig = () => {
  return useContext(ApplicationConfigContext.Context);
};

export default useApplicationConfig;
